import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

// International phone validation strategy (as opposed to the simpler 10-digit
// regex used by register/edit-profile/checkout — see PHONE_10_DIGIT_REGEX in
// @golf-district/shared). Used wherever a country dropdown lets the user enter
// a non-US number, e.g. golf-buddies and the waitlist phone-verification step.
export const validatePhoneNumber = (
  phoneNumber: string,
  countryCode: number
): true | string => {
  if (!phoneNumber) return "Phone number is required";
  try {
    const parsed = phoneUtil.parse(`+${countryCode}${phoneNumber}`);
    // isPossibleNumber/isValidNumber are two different strictness levels in
    // libphonenumber, but that distinction isn't meaningful to a user — both
    // failures mean the same thing to them, so they share one message.
    if (!phoneUtil.isPossibleNumber(parsed) || !phoneUtil.isValidNumber(parsed)) {
      return "Enter a valid phone number for the selected country";
    }
    return true;
  } catch {
    return "Enter a valid phone number for the selected country";
  }
};
